@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';

.tax-info {
  margin: 15px 0 0;
  font-size: 14px;
  line-height: 20px;
  color: @tax-info--text-color;
}

.information {
  color: var(--grey-900);
  margin: @space-4 0;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid @tax-info--border-color;
  padding-top: 5px;
  margin-top: 10px;
}

.add-margin {
  margin-right: 5px;
}
